module.exports = __webpack_public_path__ + "static/media/Dat.e6e70dbb.png";